<template>
  <div>
    <tab-warehouse v-if="job.lob !== 'RE' && job.lob !== 'RI'" ref="tabWarehouse" :context="context" :action="action" :cooperate-edit="cooperateEditWarehouse" />
    <tab-warehouse-se v-if="job.lob === 'RE' || job.lob === 'RI'" ref="tabWarehouseSe" :context="context" :action="action" :from="from" :cooperate-edit="cooperateEditWarehouse" />
    <tab-trucking v-if="showTrucking" ref="tabTrucking" :context="context" :action="action" :cooperate-edit="cooperateEditTrucking" />
  </div>
</template>

<script>
import tabWarehouse from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabWarehouse'
import tabWarehouseSe from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouse'
import tabTrucking from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabTruckingSI'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'

export default {
  name: 'TabLocalService',
  components: { tabWarehouse, tabTrucking, tabWarehouseSe },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    from: {
      type: String,
      default: () => null
    },
    cooperateEditWarehouse: { // 能否修改: 仓储
      type: Boolean,
      default: true
    },
    cooperateEditTrucking: { // 能否修改:陆运
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      job: {},
      showTrucking: true
    }
  },
  methods: {
    onShow(row, isRefresh) {
      this.job = row
      if (this.job.lob === 'RE' || this.job.lob === 'RI') {
        this.$refs['tabWarehouseSe'].onShow(row, isRefresh)
      } else {
        this.$refs['tabWarehouse'].onShow(row, isRefresh)
      }
      if (row.landTransportation) {
        if (this.showTrucking) {
          this.$refs['tabTrucking'].onShow(row, isRefresh)
        } else {
          this.showTrucking = true
          this.$nextTick(() => {
            this.$refs['tabTrucking'].onShow(row, true)
          })
        }
      } else {
        this.showTrucking = false
      }
    },
    async getSubmitData() {
      const tabWarehouseData = await this.$refs['tabWarehouse'].getSubmitData()
      const result = {}
      for (const key in tabWarehouseData) {
        result[key] = tabWarehouseData[key]
      }
      if (this.showTrucking) {
        const tabTruckingData = await this.$refs['tabTrucking'].getSubmitData()
        for (const key in tabTruckingData) {
          result[key] = tabTruckingData[key]
        }
      }
      return result
    },
    getPrintData() {
      if (!this.checkPrint()) {
        return
      }
      const obj = this.showTrucking ? this.$refs.tabTrucking.truckingInfo : null
      const params = {}
      params.JOB_UUID = this.job.uuid
      params.jobuuid = this.job.uuid
      params.WAREHOUSE_UUID = this.$refs.tabWarehouse.warehouseInfo.uuid || 'null'
      params.TRUCKING_UUID = obj && obj.uuid ? obj.uuid : 'null'
      params.category = 'WT'
      params.ctx = new SeaImportJob(this.job)
      return params
    },
    checkPrint() {
      if (this.showTrucking && this.action !== 'look') {
        const obj = this.$refs.tabTrucking.truckingInfo
        if (obj && !obj.uuid) {
          this.$message.info(this.$t('queryJob.DoorNotBeenSavedPrinted'))
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>

</style>
